import DOMPurify from 'dompurify';

// Sanitizează HTML provenit din conținut bogat (editorul Quill al modulelor) înainte de
// a-l randa prin dangerouslySetInnerHTML. Profilul implicit DOMPurify păstrează formatarea
// de bază (paragrafe, liste, link-uri, formatare text) dar elimină <script>, atribute on*
// și alți vectori XSS stocați. Vezi SECURITY_AND_ENGINEERING_AUDIT.md — Faza 1.
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');

export default sanitizeHtml;
